import { render } from "./NotesViewCard.vue?vue&type=template&id=50c3082b&scoped=true"
import script from "./NotesViewCard.vue?vue&type=script&lang=js"
export * from "./NotesViewCard.vue?vue&type=script&lang=js"

import "./NotesViewCard.vue?vue&type=style&index=0&id=50c3082b&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c3082b"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QImg,QCardSection,QCardActions,QTooltip,QSpace});
